import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";
import "./Centralparttext.scss";

const Centralpartext = () => (
  <Container
    sm={{ span: 12 }}
    md={{ span: 12 }}
    style={{
      marginLeft: "0%",
      marginTop: "0.5em",
      paddingLeft: "0em",
      width: "100%"
    }}
  >
    <Row>
      <Col
        sm={{ span: 12 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 12, offset: 0 }}
        xl={{ span: 12, offset: 0 }}
      >
        <div className="central-part-t" >
          <strong>
            Projekat realizovalo Odeljenje za umetničku dokumentaciju Muzeja
            savremene umetnosti, Beograd, u saradnji sa Odeljenjem za razvoj
            Digitalne Narodne biblioteke Srbije.{" "}
          </strong>
          <br /> <br />
          <strong>
            <font color="#666666">
              Odeljenje za umetničku dokumentaciju MSUB
            </font>
          </strong>{" "}
          prikuplja, obrađuje, katalogizira i čuva{" "}
          <strong>
            knjige, izložbene kataloge, stručnu periodiku, hemeroteku
          </strong>{" "}
          (članci iz dnevne štampe, nedeljnika i mesečnika) i{" "}
          <strong>fotodokumentaciju</strong> iz oblasti vizuelnih umetnosti, a
          posebno moderne i savremene inostrane, jugoslovenske i srpske
          umetnosti. Zahvaljujući sistematskom prikupljanju građe koje je
          pratilo formiranje zbirki i izložbe MSU, Odeljenje poseduje
          najkompletniju dokumentaciju u regionu o umetnosti i umetnicima sa
          teritorije bivše Jugoslavije. Projekat <strong>čitajte o</strong>
          ... nastao je iz potrebe da se ovaj fond učini što pristupačnijim
          istraživačima, studentima, đacima i ljubiteljima umetnosti.{" "}
          <strong>Čitajte o</strong>... predstavlja elektronsku čitaonicu u
          kojoj će se naći najkompletnije bibliografije sa celokupnim tekstovima
          o umetnicima i umetnič;kim pojavama sa prostora bivše Jugoslavije.
          Elektronska čitaonica će biti proširena foto i video dokumentacijom
          koja se čuva u Odeljenju.
          <a href="/about">
            <strong>Op&scaron;irnije</strong>&nbsp;&nbsp;
            <img width="15" src="images/strelica.jpg" alt="citajte o" />
          </a>
          <br />
        </div>
      </Col>
    </Row>
  </Container>
);

export default Centralpartext;
